export default {
    purchase: '구매',
    coupon: '할인 쿠폰',
    login_capital_letters: '로그인',
    login_capital_letters1: '로그인',
    received: '받음',
    subscribe_capital_letters: '구독하기',
    birthday_placeholder: 'MM/DD/YY',
    shop_capital_letters: '스토어',
    shop: '구매 적립',
    ecoflow_benefits: '에코 포인트 혜택',
    complete_profile: '프로필 작성',
    referral: '친구 초대하기',
    referral_desc: '추천한 친구가 회원가입할 때 마다 에코포인트가 적립됩니다',
    referral_btn: '친구 초대하기',
    warranty: '제품 등록',
    points_activity_a: '나의 활동',
    points_tab_name: '에코포인트 내역',
    rewards_tab_name: '에코포인트 적립 내역',
    coupon_used_desc: '결제 시 이 코드로 {amont} ​기프트 카드를 사용하세요.',
    email_address: '이메일 주소',
    give_away: '경품',
    kakoo_title: '카카오에서 팔로우하기',
    kakoo_desc1: '첫 팔로우 시 {points} EcoCredit을 획득하세요.',
    kakoo_desc2: '첫 팔로우 시 {points} 에코 크레딧 획득, ',
    subscribe: '구독하기',
    welcome_title: '안녕하세요 {username}님,',
    welcome_sub_title: '에코 포인트 프로그램에 오신 것을\n 환영합니다.',
    profile: '프로필 등록',
    status: '상태',
    refund: '환불',
    points_balance: '보유 포인트',
    points_progress_tips: '{plus} 되기 위해 필요한 Eco Credit: {points}에코크레딧',
    available: '사용 가능',
    sign_up_text: '회원 가입 시 500포인트',
    redeemed_succ: '성공적으로 사용했습니다!',
    current_tier: '현재 등급',
    subscribe_now: '구독하기',
    date: '날짜',
    used: '사용함',
    edeemed_rewards_note: '사용한 리워드는 여기에 표시됩니다.',
    warranty_capital_letters: '보증',
    days_rules2: '{data}부터 유효.',
    redeem_now: '바로 사용하기',
    product_rules: '{product} 상품에만 해당',
    membership_includes: '멤버십에는 다음이 포함됩니다.',
    browse_ecocredits_rewards: 'EcoCredits 리워드 찾아보기',
    discount: '할인',
    view_more: '더 보기',
    profile_desc1: '프로필 정보 등록 시 최대 1,000 포인트 적립',
    profile_desc2: '세부 정보를 입력하면 최대 1000포인트를 받을 수 있습니다.',
    points_capital_letters: '포인트',
    history_note: '에코포인트 적립 및 사용 내역은 24시간 이내로 업데이트됩니다.',
    lucky_flop_start: '참여하기',
    lucky_flop_congrat: '축하합니다',
    lucky_flop_get: '축하합니다',
    lucky_flop_open: 'OPEN',
    rules: '포인트 사용 규칙 ',
    completed_text: '포인트가 적립되었습니다.',
    redeemed: '사용됨',
    birthday: '생일 포인트',
    summary_text: '귀하의 EcoCredits 요약',
    deducted: '차감됨',
    site_rules: '에코플로우 코리아 공식 홈페이지에서만 적용 가능.',
    subscribe_hover: '회원 가입 시 500포인트가 적립됩니다.',
    subscribe_text: 'EcoFlow 뉴스레터에 가입하십시오.',
    store: '바로 구매',
    membership: '멤버',
    join_now: '지금 가입하기',
    gift_card: '기프트 카드',
    rewards_redeemed: '에코포인트 내역',
    redeedmed_tab_name: '전환 완료',
    issued_tab_name: '발급 완료',
    expired: '만료됨',
    login: '로그인',
    earn_points_title: '포인트 적립 방법',
    have_points: '에코 포인트: <code> {points} P</code>',
    view_all: '더 알아보기',
    add_your_birthday: '생년월일 입력',
    earn_point_rule_shop: '구매에 지불한 1500원당 1에코 포인트를 적립합니다.',
    off: '할인',
    earn_point_by_order: '구매 금액에 따라 에코포인트\n적립',
    registered: '등록됨',
    birthday_desc2: '생년월일을 추가하면 {points}포인트가 적립됩니다.',
    sign_up_desc_h: '회원가입 시 500포인트 즉시 적립',
    birthday_desc1: '전 회원 생일 축하 포인트 증정',
    or_text: '또는',
    profile_a: '프로필',
    days_rules: '리워드 사용일로부터 {days}일 동안 유효.',
    join_title: '에코포인트 쌓고,\n플러스 할인 받자!',
    pending: '보류 중',
    coming_soon: '곧 적립될 포인트',
    shop_to_earn_points: '쇼핑하여 포인트 적립하기',
    action: '유형',
    rewards_title: '적립 내역',
    type_title: '구분',
    discount_type: '할인 내역',
    already_member: '이미 회원이신가요?',
    already_member1: '이미 회원이신가요?',
    points_activity: '포인트 적립 내역',
    use_this_code_note: '결제 시 이 코드로 <PI1/> ​기프트 카드를 사용하세요.',
    warranty_desc2: '상품 등록 시 1000포인트가 제공됩니다.',
    warranty_desc1: '구매한 상품 정보 등록 시 1,000포인트 적립',
    redeem_ecocredits_title: '에코 포인트 전환하기',
    points: '포인트',
    benefits_link_btn: '친구추천하기 ',

    network_error: '네트워크 오류',
    confirm_text: '포인트를 사용하시겠습니까?\n사용하면 취소할 수 없습니다.',
    manually_deducted: '수동으로 차감됨',
    redeeming_points: 'EcoCredits 사용',
    earning_points: '포인트 적립',
    confirm_btn: '확인',
    faq_title: '자주 묻는 질문',
    no_enough_points: '사용하지 못했습니다. 포인트가 충분하지 않습니다.',
    no_history_note: '아직 포인트를 확인하지 못하셨나요? 활동이 24시간 이내에 업데이트됩니다.',
    no_coupon_note: '포인트 사용 내역이 없습니다.',
    minimum_price: '최소 구매 금액 ({price}).',
    minimum_num: '최소 품목 수량({num} 개).',
    stay_too_long: '오랜 기간 사용하지 않아 기간이 만료되었습니다. 페이지를 새로 고친 후 다시 시도하십시오.',
    order_rule: '할인코드의 중복적용은 불가능합니다.',
    purchas_rule: '쿠폰 금액보다 적은 금액으로 상품을 구매하는 경우,\n 차액이 회수됩니다.',
    profile_birthday: '프로필 - 생년월일',
    profile_address: '프로필 - 주소',
    profile_username: '프로필 - 성함',
    profile_picture: '프로필 - 사진',
    profile_contact: '프로필 - 연락처 정보',
    membership_faq_title: '멤버십',
    learn_more: '더 알아보기',
    profile_detail:
        '프로필을 작성해 보세요. 프로필 사진(200 포인트), 성함(100 포인트), 연락처 정보(300 포인트), 주소 정보(200 포인트), 생년월일(200 포인트) 등의 정보 등록 시 마다 최대 1000포인트를 받을 수 있습니다.',
    exceeded_counts: '포인트 전환할 수 없습니다. 전환 한도를 초과했습니다.',
    grab_title: '에코포인트? 보너스로 그냥 드려요!',
    grab_sub_title: '에코포인트 멤버를 위한 기간 한정 혜택, 지금 바로 확인해 보세요!',
    grab_btn_text: '기간 한정 혜택 받기',
    grab_success_title: '보너스 에코포인트 지급 완료',
    grab_success_text1: '보너스 에코포인트가 지급되었습니다. 자동 복사된 코드를 결제 전 입력하세요.',
    grab_success_text2: '<code>보너스 에코포인트</code> 확인하기',
    'no-grab-content-note': '더 많은 혜택을 제공해 드릴 예정입니다!',
    copy_desc_2: '할인 코드를 복사하였습니다.',
    city_validatino_error: '유효하지 않은 도시',
    product_text: '제품',
    shipping_address_text: '배송 주소',
    saved_address_text: '배송 정보를 저장하였습니다',
    use_new_address: '새 주소를 사용하기',
    spend_now: '바로 사용하기',
    stock_left: '{stock}개가 남았습니다.',
    no_stock_tip: '곧 재입고될 예정입니다.',
    order_text: '주문 번호',
    campaign_time_limit_text: '포인트 전환의 유효 기간: {startTime} - {endTime}.',
    event_action_text: '이벤트',
    warranty_minus_action_text: '보증 기록 삭제되었습니다',
    question_correctly: 'Answer the question correctly',
    follow_instagram_text: '인스타그램 팔로우',
    follow_kakoo_text: '카카오톡 팔로우',
    referral_correctly: '추천 프로그램',
    confirm_btn_text: '닫기',
    lucky_turntable_title: '행운의 룰렛',
    join_lucky_with_points: '{points} 에코 포인트로 행운의 당첨자가 되어보세요',
    join_lucky_with_points2: '{points} 에코 포인트로 행운의 당첨자가 되어보세요',
    join_lucky_desc: '룰렛을 돌리면 최대 777 포인트 (5만 4천원 상당)가 적립됩니다.',
    remaining_number: '잔여 횟수 <code></code>회',
    remaining_number2: '잔여 횟수 <code></code>회',
    learn_lucky_rule: '규칙에 대해 더 알아보기',
    prize_coupon_title: '축하합니다',
    prize_coupon_sub_title: '상품 수령에 성공했습니다! 결제 시 코드를 사용하여 할인을 받으세요.',
    prize_coupon_action: '<code>에코포인트 내역</code>에서 상품을 확인하세요.',
    prize_coupon_button: '바로 구매',
    prize_points_title: '축하합니다',
    prize_points_desc: '<code>나의 활동</code>에서 지금 추가된 EcoCredit을 확인하세요.',
    limit_times_in_day: '<day></day>일 동안 <count></count>회 참여 가능합니다',
    limit_times_in_day2: '휠을 <day></day>일 동안 <count></count>회 돌릴 수 있습니다',
    limit_times_in_day_one: '매일 <count></count>번씩 주어지는 기회!',
    limit_times_in_active: '이벤트 기간 동안 최대 <count></count>회까지 참여 가능합니다.',
    limit_times_in_active2: '이벤트 기간 동안 휠을 최대 <count></count>회까지 돌릴 수 있습니다.',
    without_limit_times: '언제든지 게임을 <count></count>회 참여할 수 있습니다.',
    without_limit_times2: '언제든지 휠을 <count></count>회 돌릴 수 있습니다.',
    active_is_unstart: '이벤트가 곧 시작됩니다.',
    active_is_ended: '이벤트가 종료되었습니다.',
    over_max_count: '사용 가능한 횟수를 초과했습니다.',
    notice_title: '알림',
    kr_subscribe_poptitle: '에코플로우 뉴스레터 등록하고 \n가장 먼저 에코플로우의 최신 소식을 받아보세요!',
    kr_subscribe_popsuccess: '구독해 주셔서 감사합니다!',
    points_cash: '포인트 사용',
    Pending1: '보류 중',
    rollback: '반환됨',
    level_change_log: '등급 변경',
    deadline: '유효 기간',
    history_refresh_member: '현재 등급: 멤버',
    history_refresh_plus_member: '현재 등급: 플러스 멤버',
    register: '멤버로 가입하기',
    upgrade: '플러스 멤버로 업그레이드',
    demotion: '멤버로 강등하기',
    relegation: '플러스 멤버 유지하기',
    ecocredits_notice1:
        '2024년 10월 17일에 EcoCredits 규칙을 업데이트했습니다. EcoCredits를 사용하기 전에 업데이트된 [<line1>EcoCredits 규칙</line1>]을 주의 깊게 읽어보시기 바랍니다.',
    wattayear_2024: '공유#WattAYear',
    clock_in: '체크인',
    copy_success1: '코드를 복사​했습니다. 코드를 사용하려면 스토어로 이동​하세요.',
};
